// hooks/useBusinessNavigation.ts
import { useNavigate } from "react-router-dom";
import { useBusinessSession } from "./useBusinessSession";
import { useBusinessRoutes } from "./useBusinessRoutes";

export const useBusinessNavigation = () => {
  const navigate = useNavigate();
  const { setSessionForBusiness } = useBusinessSession();
  const { getRouteForBusiness } = useBusinessRoutes();

  const navigateByBusiness = (businessType: string, employee?: string) => {
    setSessionForBusiness(businessType, employee);
    const route = getRouteForBusiness(businessType, employee);

    // ✅ Remove setTimeout — navigate instantly
    navigate(route, { replace: businessType === "Saloon" || businessType === "Grocery" });
  };

  return { navigateByBusiness };
};
